import styles from "./SelectUnidade.module.css";
import * as React from "react";

import {
	Box,
	Button,
	Divider,
	List,
	ListItem,
	ListItemText,
	Popover,
	Typography,
} from "@mui/material";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import DomainIcon from "@mui/icons-material/Domain";
import { useUser } from "../../context/UserContext";

function SelectUnidade(props) {
	const { user } = useUser();
	const [unidade, setUnidade] = React.useState(null);
	const [allUnidades, setAllUnidades] = React.useState([]);

	React.useEffect(() => {
		// As unidades vêm do perfil mantido em memória pelo UserContext.
		const unidadesVinculadas = user?.unidadesDistribuidoras || [];
		const unidadesArray = unidadesVinculadas.map((item) => item.unidadeDistribuidora);
		setAllUnidades(unidadesArray);

		if (unidadesArray.length === 0) {
			setUnidade(null);
			return;
		}

		const unidadeId = localStorage.getItem("selected_unidade_id");
		const currentUnidade =
			(unidadeId &&
				unidadesArray.find((u) => u.id === unidadeId || u.id === parseInt(unidadeId))) ||
			unidadesArray[0];

		localStorage.setItem("selected_unidade_id", currentUnidade.id.toString());
		if (currentUnidade.empresaDistribuidorId) {
			localStorage.setItem("selected_empresa_id", currentUnidade.empresaDistribuidorId.toString());
		}
		setUnidade(currentUnidade);
	}, [user]);

	function changeUnidade(item) {
		if (item && (!unidade || item.id !== unidade.id)) {
			setUnidade(item);
			localStorage.setItem("selected_unidade_id", item.id.toString());
			if (item.empresaDistribuidorId) {
				localStorage.setItem("selected_empresa_id", item.empresaDistribuidorId.toString());
			}
			window.location.reload(false);
		}
	}

	function formatCnpj(cnpj) {
		if (!cnpj) return "";
		const cnpjNumbers = cnpj.replace(/\D/g, "").split("");

		if (cnpjNumbers.length === 14) {
			return (
				cnpjNumbers[0] +
				cnpjNumbers[1] +
				"." +
				cnpjNumbers[2] +
				cnpjNumbers[3] +
				cnpjNumbers[4] +
				"." +
				cnpjNumbers[5] +
				cnpjNumbers[6] +
				cnpjNumbers[7] +
				"/" +
				cnpjNumbers[8] +
				cnpjNumbers[9] +
				cnpjNumbers[10] +
				cnpjNumbers[11] +
				"-" +
				cnpjNumbers[12] +
				cnpjNumbers[13]
			);
		} else {
			return cnpj;
		}
	}

	const isSidebar = props.variant === "sidebar";

	return (
		<>
			<PopupState variant="popover" sx={{ width: "50%" }}>
				{(popupState) => (
					<div>
						<Button
							sx={{
								bgcolor: isSidebar ? "rgba(255,255,255,0.15)" : "#1a9e8f",
								color: "white",
								minWidth: isSidebar ? "100%" : { xs: "0", sm: "230px" },
								maxWidth: isSidebar ? "100%" : "max-content",
								maxHeight: "50px",
								borderRadius: "8px",
								display: "flex",
								justifyContent: isSidebar ? "space-between" : "center",
								"&:hover": {
									bgcolor: isSidebar ? "rgba(255,255,255,0.25)" : "#158f80",
								},
							}}
							{...bindTrigger(popupState)}
						>
							<Box
								sx={{
									display: { xs: "none", sm: "flex" },
									flexDirection: "column",
									alignItems: "start",
									justifyContent: "center",
									minWidth: { xs: "0", sm: "80%" },
									p: 1,
									m: 0,
								}}
							>
								<Typography visibility={{ xs: "hidden", sm: "visible" }}>
									<h2 className={styles.empresaTitle}>
										{unidade?.nomeFantasia || unidade?.nome || "Selecione uma unidade"}
									</h2>
								</Typography>
								<Typography
									visibility={{ xs: "hidden", sm: "visible" }}
									className={styles.empresaCnpj}
								>
									{unidade?.cpf_cnpj ? formatCnpj(unidade.cpf_cnpj) : ""}
								</Typography>
							</Box>
							<Box
								sx={{
									display: { xs: "flex", sm: "none" },
									flexDirection: "column",
									alignItems: "start",
									justifyContent: "center",
									minWidth: { xs: "0", sm: "10%" },
									p: 0,
									m: 0,
								}}
							>
								<DomainIcon
									visibility={{ xs: "visible", sm: "hidden", md: "hidden" }}
									sx={{ width: 32, height: 32 }}
								/>
							</Box>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "start",
									justifyContent: "center",
									minWidth: { xs: "0", sm: "10%" },
									p: 0,
									m: 0,
								}}
							>
								{popupState.isOpen ? <ExpandLess /> : <ExpandMore />}
							</Box>
						</Button>
						<Popover
							{...bindPopover(popupState)}
							anchorOrigin={{
								vertical: props.verticalAnchorOrigin,
								horizontal: props.horizontalAnchorOrigin,
							}}
							transformOrigin={{
								vertical: props.verticalTransformOrigin,
								horizontal: props.horizontalTransformOrigin,
							}}
							sx={{
								ml: props.variant === "sidebar" ? 1 : 0,
							}}
						>
							<List
								sx={{
									width: "100%",
									minWidth: 280,
									maxWidth: 360,
									bgcolor: "background.paper",
									maxHeight: "40vh",
									overflow: "auto",
									py: 0.5,
								}}
							>
								{allUnidades.map((item, index) => {
									const isSelected = unidade?.id === item.id;
									return (
										<React.Fragment key={item.id}>
											<ListItem
												alignItems="flex-start"
												sx={{
													cursor: "pointer",
													py: 1,
													px: 2,
													bgcolor: isSelected ? "rgba(26, 158, 143, 0.08)" : "transparent",
													"&:hover": {
														bgcolor: isSelected ? "rgba(26, 158, 143, 0.12)" : "rgba(0, 0, 0, 0.04)",
													},
												}}
												onClick={() => changeUnidade(item)}
											>
												<ListItemText
													primary={item?.nomeFantasia || item?.nome || ""}
													secondary={item?.cpf_cnpj ? formatCnpj(item.cpf_cnpj) : ""}
													primaryTypographyProps={{
														fontSize: "0.875rem",
														fontWeight: isSelected ? 600 : 400,
														color: isSelected ? "#1a9e8f" : "inherit",
													}}
													secondaryTypographyProps={{
														fontSize: "0.75rem",
													}}
												/>
											</ListItem>
											{index < allUnidades.length - 1 && (
												<Divider component="li" />
											)}
										</React.Fragment>
									);
								})}
							</List>
						</Popover>
					</div>
				)}
			</PopupState>
		</>
	);
}
export default SelectUnidade;
